// extracted by mini-css-extract-plugin
export default {"container":"events-table_container__HKAoP","truncate-table":"events-table_truncate-table__JmXhR","table-text-faded":"events-table_table-text-faded__QrNdX","badge":"events-table_badge__XQf9Z","badgeYellow":"events-table_badgeYellow__97sz1","badgeRed":"events-table_badgeRed__Uf-RW","badgeBlue":"events-table_badgeBlue__oD7Em","productLink":"events-table_productLink__4kuHm"};
    if(module.hot) {
      // 1793877079085
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  